import { render, staticRenderFns } from "./empty-permissions-page.vue?vue&type=template&id=6a165851&"
import script from "./empty-permissions-page.vue?vue&type=script&lang=js&"
export * from "./empty-permissions-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports